export default {
  upload: {
    title: 'Drop your .png or .jpg file here',
    another: 'Another file'
  },
  local_db: {
    title: 'Local DB'
  },
  chart: {
    doughnut: {
      title: 'Doughnut chart'
    },
    timeseries: {
      title: 'Time series chart'
    }
  }
}
